// Dinheiro em centavos (inteiro) — nunca float, para o total da Fatura fechar.

export type Centavos = number;

/** Converte "R$ 1.234,56", "1234,56", "2,50" ou "250" em centavos. */
export function parseReais(input: string): Centavos {
  const limpo = input
    .trim()
    .replace(/^R\$\s*/i, "")
    .replace(/\s/g, "")
    .replace(/\.(?=\d{3}(\D|$))/g, "") // pontos de milhar
    .replace(",", ".");
  const n = Number(limpo);
  if (limpo === "" || !Number.isFinite(n) || n < 0) {
    throw new Error("Informe um valor em reais válido.");
  }
  return Math.round(n * 100);
}

/** Centavos → "R$ 2,50". */
export function formatReais(centavos: Centavos): string {
  return (centavos / 100).toLocaleString("pt-BR", {
    style: "currency",
    currency: "BRL",
  });
}
